import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { signInImage } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';

export default function HomeScreenLogin() {
  const dispatch = useDispatch()
  const Login = useSelector((state) => state.LoginState);

  return (
    <div style={{ height: "100vh", backgroundColor: "#fff", marginTop: 10 }}>
      <div className="row">
        <div style={{ margin: "10px" }} className="center">
          <img
            src={signInImage}
            style={{ height: "30vh", width: "30vh", objectFit: "contain" }}
          />
        </div>
        <div className="row" >
          <Link to={Login.token !== null ? `${slugs.daily_exam}` : "/login"} className="col-sm-4 col-6 center" style={{ padding: "20px" }}>
            <img
              className="home-icons"
              src="https://api.akbeducation.com/wp-content/uploads/2025/11/ubt-exam.png"
            />
            <div className="home-fonts">
              All Exam
            </div>
          </Link>
          <Link to={`${slugs.classroom}`} className="col-sm-4 col-6 center" style={{ padding: "20px" }}>
            <img
              className="home-icons"
              src="https://api.akbeducation.com/wp-content/uploads/2025/11/classtest.png"
            />
            <div className="home-fonts">
              Class Test
            </div>
          </Link>
          <Link to={Login.token !== null ? `${slugs.course}` : "/login"} className="col-sm-4  col-6 center" style={{ padding: "20px" }}>
            <img
              className="home-icons"
              src="https://api.akbeducation.com/wp-content/uploads/2025/11/course.png"
            />
            <div className="home-fonts">
              Online Class & Video
            </div>
          </Link>
          <Link to={Login.token !== null ? `${slugs.books}` : "/login"} className="col-sm-4 col-6 center" style={{ padding: "20px" }}>
            <img
              className="home-icons"
              src="https://api.akbeducation.com/wp-content/uploads/2025/11/books.png"
            />
            <div className="home-fonts">
              Books
            </div>
          </Link>
          <Link to={Login.token !== null ? `${slugs.demo_exam}` : "/login"} className="col-sm-4 col-6 center">
            <img
              className="home-icons"
              src="https://api.widihakwon.com/wp-content/uploads/2024/03/textbook.png"
            />
            <div className="home-fonts">
              Free Exam
            </div>
          </Link>
          <Link to={Login.token !== null ? `/profile` : "/login"} className="col-sm-4 col-6 center">
            <img
              className="home-icons"
              src="https://api.akbeducation.com/wp-content/uploads/2025/11/profile.png"
            />
            <div className="home-fonts">
              {Login.token !== null ? "Profile" : "Login"}
            </div>
          </Link>

        </div>

      </div>
    </div>
  )
}